import { fulfillmentStateLabels, type FulfillmentState } from '../../domain/fulfillment';

/** State as text first; the colour only reinforces it. */
export function OrderStateBadge({ state }: { state: FulfillmentState }) {
  const tone =
    state === 'READY_TO_HANDOVER'
      ? ' state-badge-ready'
      : state === 'CANCELLED'
        ? ' state-badge-muted'
        : state === 'PICKING' || state === 'READY_TO_PICK'
          ? ' state-badge-active'
          : '';
  return <span className={`state-badge${tone}`}>{fulfillmentStateLabels[state]}</span>;
}

export function ProgressMeter({
  complete,
  total,
  label,
}: {
  complete: number;
  total: number;
  label: string;
}) {
  return (
    <span className="progress-meter">
      <progress value={complete} max={Math.max(total, 1)} aria-label={label} />
      <span className="progress-meter-text">
        {complete}/{total}
      </span>
    </span>
  );
}
